import { useTranslation } from "react-i18next";

export default function ContactUsCard() {
  const { t } = useTranslation();

  return (
    <div className="container ui-component-spacing">
      <div className="ui-card p-4 sm:p-6">
        <h2 className="font-body text-xl font-bold">
          {t("ContactUsCard-section-1-title")}
        </h2>
        <hr className="my-4" />
        <div className="grid gap-4 grid-cols-3 md:gap-8">
          <div>
            <div className="font-semibold">
              {t("ContactUsCard-section-1-method-1-title")}
            </div>
            <div className="text-sm">
              <div>{t("ContactUsCard-section-1-method-1-addressLine-1")}</div>
              <div>{t("ContactUsCard-section-1-method-1-addressLine-2")}</div>
              <div>{t("ContactUsCard-section-1-method-1-addressLine-3")}</div>
            </div>
          </div>
          <div>
            <div className="font-semibold">
              {t("ContactUsCard-section-1-method-2-title")}
            </div>
            <div className="text-sm">
              <div>{t("ContactUsCard-section-1-method-2-addressLine-1")}</div>
              <div>{t("ContactUsCard-section-1-method-2-addressLine-2")}</div>
              <div>{t("ContactUsCard-section-1-method-2-addressLine-3")}</div>
            </div>
          </div>

          <div>
            <div className="font-semibold">
              {t("ContactUsCard-section-1-method-3-title")}
            </div>
            <div className="text-sm">
              <div>{t("ContactUsCard-section-1-method-3-addressLine-1")}</div>
              <div>{t("ContactUsCard-section-1-method-3-addressLine-2")}</div>
              <div>{t("ContactUsCard-section-1-method-3-addressLine-3")}</div>
            </div>
          </div>
        </div>

        <h2 className="font-body text-xl font-bold pt-8">
          {t("ContactUsCard-section-2-title")}
        </h2>
        <hr className="my-4" />
        <div className="grid gap-4 grid-cols-3 md:gap-8">
          <div>
            <div className="font-semibold">
              {t("ContactUsCard-section-2-method-1-title")}
            </div>
            <div className="text-sm">
              <div>{t("ContactUsCard-section-2-method-1-addressLine-1")}</div>
              <div>{t("ContactUsCard-section-2-method-1-addressLine-2")}</div>
              <div>{t("ContactUsCard-section-2-method-1-addressLine-3")}</div>
            </div>
          </div>
          <div>
            <div className="font-semibold">
              {t("ContactUsCard-section-2-method-2-title")}
            </div>
            <div className="text-sm">
              <div>{t("CustomerContactUs-attn")}</div>
              <div>{t("ContactUsCard-section-2-method-2-addressLine-1")}</div>
              <div>{t("ContactUsCard-section-2-method-2-addressLine-2")}</div>
              <div>{t("ContactUsCard-section-2-method-2-addressLine-3")}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
